import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    soluciones: ['ingenieria', 'compliance', 'financiacion', 'estudioGratuito'],
    sectores: ['manufacturera', 'agroalimentario', 'casosExito', 'referencias'],
    empresa: ['sobreAurion', 'metodo', 'equipo', 'contacto'],
    recursos: ['noticias', 'faqs', 'documentacion', 'blog']
  };

  const contactInfo = [
    { icon: 'ri-mail-line', text: 'info@aurionenergy.es', link: 'mailto:info@aurionenergy.es' },
    { icon: 'ri-phone-line', text: '+34 900 000 000', link: 'tel:+34900000000' },
    { icon: 'ri-map-pin-line', text: 'P.º de la Castellana, 130, Plantas 9 y 10, Chamartín, 28046 Madrid, Spain', link: '#' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-6 gap-8">
          <div className="lg:col-span-2">
            <img src="https://static.readdy.ai/image/d2dacb92e0221beafae8fac9226481ac/5086d91de1caebf58e4a66cae0029c78.png" alt="AURION" className="h-52 w-auto mb-6 brightness-0 invert" />
            <div className="space-y-3">
              {contactInfo.map((contact, index) => (
                <a key={index} href={contact.link} className="flex items-center space-x-3 text-gray-300 hover:text-white transition-colors duration-200">
                  <i className={`${contact.icon} text-teal-400`}></i>
                  <span>{contact.text}</span>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">{t('footer.soluciones')}</h4>
            <ul className="space-y-2">
              {footerLinks.soluciones.map((link, index) => (
                <li key={index}><a href="#" className="text-gray-300 hover:text-white transition-colors">{t(`footer.${link}`)}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">{t('footer.sectores')}</h4>
            <ul className="space-y-2">
              {footerLinks.sectores.map((link, index) => (
                <li key={index}><a href="#" className="text-gray-300 hover:text-white transition-colors">{t(`footer.${link}`)}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">{t('footer.empresa')}</h4>
            <ul className="space-y-2">
              {footerLinks.empresa.map((link, index) => (
                <li key={index}><a href="#" className="text-gray-300 hover:text-white transition-colors">{t(`footer.${link}`)}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">{t('footer.recursos')}</h4>
            <ul className="space-y-2">
              {footerLinks.recursos.map((link, index) => (
                <li key={index}><a href="#" className="text-gray-300 hover:text-white transition-colors">{t(`footer.${link}`)}</a></li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
              <p className="text-gray-400 text-sm">© 2025 AURION ENERGY S.L. {t('footer.derechos')}</p>
              <div className="flex space-x-4">
                <a href="/privacidad" className="text-gray-400 hover:text-white text-sm">{t('footer.privacidad')}</a>
                <a href="/terminos" className="text-gray-400 hover:text-white text-sm">{t('footer.terminos')}</a>
                <a href="/cookies" className="text-gray-400 hover:text-white text-sm">{t('footer.cookies')}</a>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <span className="text-gray-400 text-sm">{t('footer.siguenos')}</span>
              <div className="flex space-x-3">
                <a href="#" className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors"><i className="ri-linkedin-fill text-sm"></i></a>
                <a href="#" className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors"><i className="ri-twitter-fill text-sm"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
